import { Injectable, TemplateRef } from "@angular/core";
import { Observable } from "rxjs";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzDrawerPlacement, NzDrawerRef } from "ng-zorro-antd/drawer";

@Injectable({ providedIn: "root" })
export abstract class DrawerRef<T = NzSafeAny, R = NzSafeAny> extends NzDrawerRef {
  public abstract afterClose: Observable<R>;
  public abstract afterOpen: Observable<void>;
  public abstract close(result?: R): void;
  public abstract open(): void;
  public abstract getContentComponent(): T | null;
  public abstract uiClosable?: boolean;
  public abstract uiMaskClosable?: boolean;
  public abstract uiKeyboard?: boolean;
  public abstract uiMask?: boolean;
  public abstract uiTitle?: string | TemplateRef<unknown>;
  public abstract uiPlacement?: NzDrawerPlacement;
  public abstract uiMaskStyle?: object;
  public abstract uiBodyStyle?: object;
  public abstract uiWrapClassName?: string;
  public abstract uiWidth?: number | string;
  public abstract uiHeight?: number | string;
  public abstract uiZIndex?: number | string;
  public abstract uiOffsetX?: number | string;
  public abstract uiOffsetY?: number | string;
}
